//import React from 'react';
import React, { useState, useLayoutEffect, useRef, useEffect } from 'react';

import Router from './routes/Router';
import Header from './components/Header';
import Footer from './components/Footer';
import { gsap } from 'gsap';
import { useGSAP } from "@gsap/react";
import { DrawSVGPlugin } from './js/DrawSVGPlugin.js';
import ScrollTrigger from 'gsap/ScrollTrigger'; 
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollSmoother);



//<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< ===================================================== Update Scrolltrigger bug 8-24-2026  
// Stops the browser from overriding your initial scroll position on production refresh
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}


// XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
// REACT JS USER GIUIDE - https://github.com/facebook/create-react-app/blob/main/packages/cra-template/template/README.md
// XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX


// Import Images To Pre load Here
// XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX

// HEROS
import loadng_guage_spinner from './images/spinner.svg';
import heroimg_home from './images/heros/home.webp'; // Tell webpack this JS file uses this image / Also use JPGs not WEBP a bug.
import heroimg_portfolio from './images/heros/portfolio.webp'; 
import heroimg_services from './images/heros/services.webp'; 
import heroimg_profile from './images/heros/profile.webp'; 
import heroimg_contact from './images/heros/contact.webp'; 
import heroimg_archive from './images/heros/archive.webp'; 

// HOME PAGE
// ------------------------------------//
// Butterfly
import heroimg_butterfly_lwing from './images/heros/buttefly-wing-left.webp';
import heroimg_butterfly_rwing from './images/heros/buttefly-wing-right.webp';
import heroimg_butterfly_body from './images/heros/butterfly-body.webp';
import heroimg_butterfly_fx_code from './images/heros/buttefly-wing-fx-code.webp'; // to be deleted since we had 2 layer and one works best
import heroimg_butterfly_fx_code_top from './images/heros/buttefly-wing-fx-code-top.webp';
import heroimg_butterfly_glitch_fx_1 from './images/heros/butterfliy-glitch-effect-1.webp';
import heroimg_butterfly_glitch_fx_2 from './images/heros/butterfliy-glitch-effect-2.webp';
import heroimg_butterfly_glitch_fx_3 from './images/heros/butterfliy-glitch-effect-3.webp';
import heroimg_butterfly_glitch_fx_4 from './images/heros/butterfliy-glitch-effect-4.webp';
import heroimg_butterfly_glitch_fx_5 from './images/heros/butterfliy-glitch-effect-5.webp';
import heroimg_butterfly_glitch_fx_6 from './images/heros/butterfliy-glitch-effect-6.webp';
import assurance_section_bg from './images/home/assurance-bg.webp'; 

// Light rays FX bg
import light_rays from './images/light-rays.svg'; 
import home_img_1 from './images/home-services-graphic-design.webp'; 
import home_img_2 from './images/home-services-web-development.webp'; 

// Graphic Design Slides
import gd_slide_1 from './images/home/home-services-graphic-design-01.webp'; 
import gd_slide_2 from './images/home/home-services-graphic-design-02.webp'; 
import gd_slide_3 from './images/home/home-services-graphic-design-03.webp'; 
import gd_slide_4 from './images/home/home-services-graphic-design-04.webp';
import gd_slide_5 from './images/home/home-services-graphic-design-05.webp';  

// Web Development Slides
import wd_slide_1 from './images/home/home-services-web-development-01.webp'; 
import wd_slide_2 from './images/home/home-services-web-development-02.webp'; 
import wd_slide_3 from './images/home/home-services-web-development-03.webp'; 
import wd_slide_4 from './images/home/home-services-web-development-04.webp';
import wd_slide_5 from './images/home/home-services-web-development-05.webp'; 
 
// Assurance 
import assurance_pantone_book from './images/home/assurance-pantone-book.webp';
import assurance_phone_pen from './images/home/assurance-phone-pen.webp';  

/* FEATURED */
import home_featured_img_1 from './images/featured/featured-graphic-design.webp'; 
import home_featured_img_2 from './images/featured/featured-web-development.webp'; 

// SERVICES
// ------------------------------------//
import services_img_1 from './images/services/services-page-web-development.webp'; 

/*
import lightbulb_1_back from './images/services/hero-lightbulb-1-back.webp'; 
import lightbulb_1_front from './images/services/hero-lightbulb-1-front.webp'; 
import lightbulb_1_light from './images/services/lighthouse-light-glare.webp'; 
import lightbulb_2_back from './images/services/hero-lightbulb-2-back.webp'; 
import lightbulb_2_front from './images/services/hero-lightbulb-2-front.webp'; 
import lightbulb_3_back from './images/services/hero-lightbulb-3-back.webp'; 
import lightbulb_3_front from './images/services/hero-lightbulb-3-front.webp';
*/

import lightbulb_1 from './images/services/graphic-design-services-bulb-lighthouse.webp'; 
import lightbulb_1_front from './images/services/graphic-design-services-bulb-lighthouse-light.webp'; 
import lightbulb_2 from './images/services/graphic-design-services-bulb-hotel.webp';  
import lightbulb_3 from './images/services/graphic-design-services-bulb-beach-ball.webp'; 
import lightbulb_3_back from './images/services/graphic-design-services-bulb-beach.webp'; 
import graphic_design_section_bg from './images/services/graphic-design-services-hero-bg.webp'; 


import services_quote_icon from './images/icons/icon-estimate.svg'; 
//import graphic_design_section_bg from './images/services/graphic-design-twirl-bg.webp'; 
import web_dev_devices_bg from './images/services/services-screens-saver.webp'; 

//Profile
import experience_profile_bg from './images/profile/clouds-bg.webp';
import laptop_base from './images/laptop/base.webp';
import laptop_screen from './images/laptop/screen-1.webp';
import laptop_spacer from './images/laptop/laptop-spacer.webp';
import hero_sailboat from './images/profile/hero-sailboat.png';
import laptop_spotlight_fx1 from './images/laptop/light-ray.svg';
import laptop_spotlight_fx2 from './images/laptop/light-ray.svg';
import laptop_spotlight_fx3 from './images/laptop/light-ray.svg';
import edu_book_1 from './images/profile/book-1.webp';
import edu_book_2 from './images/profile/book-2.webp';
import edu_book_3 from './images/profile/book-3.webp';
import edu_book_4 from './images/profile/book-4.webp';
import edu_book_5 from './images/profile/book-5.webp';
import edu_book_6 from './images/profile/book-6.webp';
import edu_book_7 from './images/profile/book-7.webp';
import edu_book_8 from './images/profile/book-8.webp';
import edu_book_9 from './images/profile/book-9.webp';

//Archive
import heroimg_archive_top from './images/heros/archive-ufo-glow.webp';
import heroimg_archive_beam from './images/heros/archive-beam.webp';

// Background images in CSS
import bg_footer_react_icon from './images/icons/icon-react-logo.svg'; 






function App() {

  const container = useRef();

  useGSAP(() => {


  gsap.to(".spinner-cont", {autoAlpha: 1, duration: 2, ease: "power4.out"})



    
    gsap.registerPlugin(DrawSVGPlugin, ScrollSmoother, ScrollTrigger);
  


    // **********************************//
    // MATCH MEDIA MOBILE 
    // **********************************//
    let mmapp = gsap.matchMedia();
    // Desktop animation
    mmapp.add("(min-width: 800px)", () => {


    //----------------------------------//
    //SITE SCROLLSMOOTHER
    // ---------------------------------//
    global.sScroll = ScrollSmoother.create({
     smooth: 1,              
     effects: true,       
     smoothTouch: 0.1,     
    });

    // PAGE REFRESH
    window.onload = setScrollTop;
       function setScrollTop() {  
           sScroll.scrollTo(0, false); // rest to top for semaless transition since a SPA
       }



}); // END of MATCH MEDIA MOBILE =  800 <<< XXXXXXXXXXXXX





  
 


     // XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
     // I M A G E   P R E L O A D E R (REDONE)
     // XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
    function preloadImages(urls, allImagesLoadedCallback) {

         // 1. SET GLOBAL PRELOAD FLAG TO TRUE IMMEDIATELY   <<
       window.isInitialPreload = true;


      let pbar = document.querySelector('.pbar_indicator');
      let loadedCounter = 0;
      let toBeLoadedNumber = urls.length;

      if (toBeLoadedNumber === 0) {

            // 2. SET TO FALSE IF THERE ARE NO IMAGES TO LOAD   <<
            window.isInitialPreload = false;
        allImagesLoadedCallback();
        return;
      }

      urls.forEach(function (url) {
        preloadImage(url, function () {
          loadedCounter++;
          console.log('Number of loaded images: ' + loadedCounter);

          // Calculate exact progress percentage dynamically
            if (pbar) {
              let percentage = Math.round((loadedCounter / toBeLoadedNumber) * 100);
              pbar.style.width = percentage + '%';
            }

            if (loadedCounter === toBeLoadedNumber) {
                      // 3. SET TO FALSE ONCE ALL IMAGES ARE SECURELY LOADED  <<
                      window.isInitialPreload = false;
               allImagesLoadedCallback();
            }
            });
        });

      function preloadImage(url, anImageLoadedCallback) {
        var img = new Image();
        img.onload = anImageLoadedCallback;
        img.onerror = anImageLoadedCallback; // Handles missing images gracefully so preloader won't hang
        img.src = url;
      }
    }
  
  // Let's call it:
  preloadImages([
    loadng_guage_spinner,
    heroimg_home,
    home_img_1,
    home_img_2,
    heroimg_portfolio,
    heroimg_services,
    heroimg_profile,
    heroimg_contact,
    heroimg_butterfly_lwing,
    heroimg_butterfly_rwing,
    heroimg_butterfly_body,
    heroimg_butterfly_fx_code,
    heroimg_butterfly_fx_code_top,
    heroimg_butterfly_glitch_fx_1,
    heroimg_butterfly_glitch_fx_2,
    heroimg_butterfly_glitch_fx_3,
    heroimg_butterfly_glitch_fx_4,
    heroimg_butterfly_glitch_fx_5,
    heroimg_butterfly_glitch_fx_6,
    assurance_section_bg,
    light_rays,
    home_img_1,
    home_img_2,
    gd_slide_1,
    gd_slide_2,
    gd_slide_3,
    gd_slide_4,
    gd_slide_5,
    wd_slide_1,
    wd_slide_2,
    wd_slide_3,
    wd_slide_4, 
    wd_slide_5,
services_img_1,
lightbulb_1,
lightbulb_1_front,
lightbulb_2,
lightbulb_3_back,
lightbulb_3,
services_quote_icon,
graphic_design_section_bg,
laptop_base,
laptop_screen,
laptop_spacer,
hero_sailboat,
laptop_spotlight_fx1,
laptop_spotlight_fx2,
laptop_spotlight_fx3,
edu_book_1,
edu_book_2,
edu_book_3,
edu_book_4,
edu_book_5,
edu_book_6,
edu_book_7,
edu_book_8,
edu_book_9,
heroimg_archive_top,
heroimg_archive_beam,
web_dev_devices_bg,
experience_profile_bg 

  ], function(){
       // all loading completed call
       console.log('All images were loaded');
       // <<<< START SITE LOADING 
      StartAnm();
  })
  // EOF Image Preloader >>>>>>>>>>


 // GET PAGE ID FROM CLASS NAME - This is for the inital animation when page is visited from a bookmarked or copeid URL.
 // ================================= //   
let pageid = document.querySelector(".page-content");
let pageidis = pageid ? pageid.getAttribute('data-page-id') : 'home';
//console.log(pageidis);


// INTRO ANIMATION - Preloading Animation and Page Animation Transition
// ============================== //
const showtl = gsap.timeline({});

// preset
// remove the added bg fill class upon reload, revisit
var mainbg = document.querySelector(".layout-content-wrapper");
// Get screenHeight
let screenHeight = window.innerHeight;
let screenPos = screenHeight / 2;
let loader_spinner = document.querySelector(".spinner");
if (loader_spinner) {
  loader_spinner.style.top = screenPos + "px";
}



// =============================== //
// PRESETS >>>>>>>>>>>>>>
// =============================== //  
              gsap.set(".hero-text strong", {y:"50px", autoAlpha: 0});
              gsap.set(".h1-accent", {width:"0px"});





// STARTER ANIMATION - Not transition
// ===================================== //
  // ANIMATE HERO

function StartAnm(){
  
// PRESETS HERO
 //gsap.set(".home-transition-curtain", {left:"-4000", top:"-4000"});
 //gsap.set(".portfolio-transition-curtain", {left:"-4000", top:"-4000"});
 //gsap.set(".services-transition-curtain", {left:"-4000", top:"-4000"});
//gsap.set(".profile-transition-curtain", {left:"-4000", top:"-4000"});
//gsap.set(".contact-transition-curtain", {left:"-4000", top:"-4000"});
//gsap.set(".archieve-transition-curtain", {left:"-4000", top:"-4000"});


const timer = setTimeout(() => {

// ANIMATION - TRANSITTION SPLASH MASK
// -------------------------------------//
   let heromask1 = document.querySelector("#dotmask");
   let heromask2 = document.querySelector("#hoopmask");
   // Preset it
   gsap.set(heromask1 ,{scale:0});
   gsap.set(heromask2 ,{scale:0});

   var tl_hero_trans = gsap.timeline({});

   /*
   tl_hero_trans.to(heromask1, {scale:1, duration: 1.5, ease: "power4.out", delay:1})
   .to(heromask2, {scale:1, duration: 1.5, ease: "power4.out", delay:-1.25});
   */
      //Presets
      gsap.set(".page-id_"+pageidis, {backgroundPosition: "0px 4000px"});
      gsap.set(".site-nav-menu", {opacity: 0, marginRight: "100px"});
       gsap.set(".menubutton", {opacity: 0, marginRight: "100px"});
      gsap.set(".brand-logo", {opacity: 0, marginLeft: "100px"});

      
      // Remove previous background for the shuffle
      if (mainbg) {
        mainbg.classList.remove("bg-home-fill");
        mainbg.classList.remove("bg-portfolio-fill");
        mainbg.classList.remove("bg-services-fill");
        mainbg.classList.remove("bg-profile-fill");
        mainbg.classList.remove("bg-contact-fill");
        mainbg.classList.remove("bg-archive-fill");
      }

     
// ANIMATION - TRANSITTION SPLASH DOT - used to change the color, this is shown first.
// -------------------------------------//
      showtl.to(".preloader-bar", {autoAlpha: 0, duration: 1, ease: "power4.out", onStart:addBGfill})
      .to(".spinner-cont", {y: "-42vh", x: "-42vw", autoAlpha: 0, duration: 1.5, ease: "power4.out", delay:-0.25}) // animates to top left corner
      .to(".preloader", {autoAlpha: 0, duration: 3, ease: "power4.out", delay:-2, onComplete:stopPreloader});

      if (heromask1) {
      showtl.to(heromask1, {scale:1, duration: 1.5, ease: "power4.out", delay:-2}); //<<<<<<<<<<<<<<<<<<<<<<< LAST HERE - WE ADDED THE CONDITIONALS SO FAR
      }
      if (heromask2) {
       showtl.to(heromask2, {scale:1, duration: 1.5, ease: "power4.out", delay:-1.75});
      }
     // ANIMATE INITIAL TRANSITION SPLASH - Lets animate this out before they see the page so we have a solid color specifically for an inital loading of our SPA
     //.to("."+pageidis+"-transition-curtain", {left:"-1000px", top:"-1000px", transformOrigin:"top top", duration: 0.5, ease: "power4.out",delay:-2, })


     let mm_nav_ui = gsap.matchMedia();

mm_nav_ui.add("(min-width: 800px)", () => {
         showtl.to(".brand-logo", {marginLeft: "0px", autoAlpha: 1, duration: 1.5, ease: "power4.out",delay:-0.5})
       .to(".site-nav-menu", {marginRight: "0px", autoAlpha: 1, duration: 1.5, ease: "power4.out", delay:-1.25})
       .to(this, {duration: 1, delay:"-1", onStart:IntialHeadingFX});
});


mm_nav_ui.add("(max-width: 799px)", () => {
         gsap.set(".site-nav-menu", {opacity: 1, marginRight: "0px"});
         showtl.to(".brand-logo", {marginLeft: "0px", autoAlpha: 1, duration: 1.5, ease: "power4.out",delay:-0.5})
       .to(".menubutton", {marginRight: "0px", autoAlpha: 1, duration: 1.5, ease: "power4.out", delay:-1.25})
       .to(this, {duration: 1, delay:"-1", onStart:IntialHeadingFX});
});




   }, 2000);
  }


  function stopPreloader(){
    // stop preloader animation
const spinner = document.querySelector(".spinner");
if (spinner) spinner.classList.add("pauseanimation");
  }
  


function IntialHeadingFX() {
  let splitTitle2 = new SplitText(".page-h1 h1", {
    type: "words,chars",
  });
  let chars = splitTitle2.chars;
  // 2. Hide the split characters immediately so they don't flash
    gsap.set(".page-h1 h1", { autoAlpha: 1 });
  gsap.set(chars, { opacity: 0, y: 10 });


  let tlh1text = gsap.timeline({});
  tlh1text
    .to(chars, {
      duration: 0.2,
      opacity: 1,
      y: 0,
      ease: "none",
      stagger: {
        each: 0.05,
        from: "random",
      },
    })
    .to(".h1-accent", { width: "140px", duration: 1, ease: "power4.out" }, "-=0.2")
    .to(".hero-text strong", { y: "0px", autoAlpha: 1, duration: 1, ease: "power4.out" }, "-=0.5");
}





let addBGfill = () => {

        // XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
     // ON ENTERED - for sycing animation on landing pages, home, contact... - let the inital animations start to play when all is done!
    // 🔔 ALERT THE EXACT SECOND ADDLBGFILL RUNS: - this is also in APP.JS!!!!!
     window.dispatchEvent(new CustomEvent('masterTransitionDone', { detail: { pageidis } }));

      // adds repeated background image to fill in for effect
      if (mainbg) {
        if(pageidis == "home"){
          mainbg.classList.add("bg-home-fill");
        }
        if(pageidis == "services"){
          mainbg.classList.add("bg-services-fill");
        }
        if(pageidis == "portfolio"){
          mainbg.classList.add("bg-portfolio-fill");
        }
        if(pageidis == "profile"){
          mainbg.classList.add("bg-profile-fill");
        }
        if(pageidis == "contact"){
          mainbg.classList.add("bg-contact-fill");
        }
        if(pageidis == "archive"){
          mainbg.classList.add("bg-archive-fill");
        }
      }
    
    }



  
  


    



// ===================================== //
// NAVIGATION
// =================================== //

    /* MAIN NAV BAR - dynamic colored background on scroll */ 
    let dbg = document.querySelector('.dyn-background');        
    let checkScrolled = false;
        
    if ( dbg ) { 
        window.addEventListener("scroll", () => {
          if (window.scrollY > 175) {
            if (checkScrolled == false){  
              dbg.classList.remove("fade-bg-out");  
              dbg.classList.add("fade-bg-in");
              checkScrolled = true;
            }
          } else {
              if (checkScrolled == true){
                 dbg.classList.remove("fade-bg-in"); 
                 dbg.classList.add("fade-bg-out");
                 checkScrolled = false;
              }
          }
        }); 
    }

// LINK HOVER  - text effect
const navlinks= document.querySelectorAll(".site-nav-menu a");
navlinks.forEach(links => {
  const split = new SplitText(links, { type: 'chars' });
  const tl_nav_links = gsap.timeline({ paused: true });
  
  gsap.set(links, { perspective: 400 });
  gsap.set(split.chars, { transformStyle: "preserve-3d" });
  
  tl_nav_links.to(split.chars, {
    rotationX: 360,
    color:"#f0cc77",
    transformOrigin: "center center",
    stagger: {
      each: 0.05,
      from: "random"
    },
    duration: 0.6,
    ease: "back.out(1.5)"
  });
  
  links.addEventListener('mouseenter', () => tl_nav_links.play());
  links.addEventListener('mouseleave', () => tl_nav_links.reverse());
});




// LOGO ANIMATION
// --------------------------------------//


// ohver over this = .mhd-nav-logo
// animate this = .site-logo-stripe-1. .site-logo-stripe-2  .....


// Target all 5 stripes in order (top to bottom)
const allStripes = [
  '#site-logo-stripe-1',
  '#site-logo-stripe-2',
  '#site-logo-stripe-3',
  '#site-logo-stripe-4',
  '#site-logo-stripe-5'
];

const logo = document.querySelector('#mhd-nav-logo');

// Create paused infinite timeline
const stripeLoop = gsap.timeline({ repeat: -1, paused: true });

stripeLoop.to(allStripes, {
  opacity: 0,
  duration: 0.4,
  ease: 'power2.inOut',
  stagger: {
    each: 0.15, // Delay before the next stripe begins fading
    yoyo: true, // Fades down to 0 and back up to 1
    repeat: 1
  }
});

if (logo) {
  // Play sequence on hover
  logo.addEventListener('mouseenter', () => {
    stripeLoop.play();
  });

  // Pause and reset all stripes to full opacity on leave
  logo.addEventListener('mouseleave', () => {
    stripeLoop.pause();
    gsap.to(allStripes, {
      opacity: 1,
      duration: 0.3,
      ease: 'power2.out'
    });
  });
}


    // FOOTER ANIMATIONS
    // ==================================== //


const bgLayer = document.querySelector(".footer-bg-layer");
const footerLinks = document.querySelectorAll(".footer-cta-wrap a");

// preset
if (bgLayer) gsap.set(bgLayer, { opacity: 0 });

const backgroundScroll = gsap.to(bgLayer, {
  backgroundPositionX: "160px", 
  duration: 5,                  
  ease: "none",                 
  repeat: -1,
  paused: true // Don't move until hovered
}); 

footerLinks.forEach(link => {
  link.addEventListener("mouseenter", () => {
    backgroundScroll.play();                     
    if (bgLayer) gsap.to(bgLayer, { opacity: 1, duration: 0.4 }); 
  });
  
  link.addEventListener("mouseleave", () => {
    backgroundScroll.pause();                     
    if (bgLayer) gsap.to(bgLayer, { opacity: 0, duration: 0.4 }); 
  });
  
});


// LINK HOVER  - text effect
footerLinks.forEach(link => {
  const split = new SplitText(link, { type: 'chars' });
  const tl_footer_links = gsap.timeline({ paused: true });
  
  gsap.set(link, { perspective: 400 });
  gsap.set(split.chars, { transformStyle: "preserve-3d" });
  
  tl_footer_links.to(split.chars, {
    rotationX: 360,
    color:"#f0cc77",
    transformOrigin: "center center",
    stagger: {
      each: 0.05,
      from: "random"
    },
    duration: 0.6,
    ease: "back.out(1.5)"
  });
  
  link.addEventListener('mouseenter', () => tl_footer_links.play());
  link.addEventListener('mouseleave', () => tl_footer_links.reverse());
});



// CREDITS LINK & WINDOW
// ====================================================//
//.react-link
//.credits-window

// 1. Create a paused timeline for the credits window
const creditsTl = gsap.timeline({ paused: true });

creditsTl.fromTo(
  ".credits-window",
  { 
    autoAlpha: 0, // Handles both opacity and visibility
    y: 20         // Subtle upward slide
  },
  { 
    autoAlpha: 1, 
    y: 0, 
    duration: 0.4, 
    ease: "power2.out" 
  }
);

// 2. Target .credit-info for the click handler
const creditInfo = document.querySelector(".credit-info");

creditInfo.addEventListener("click", (e) => {
  e.preventDefault();
  
  // Toggle the timeline between play and reverse
  if (creditsTl.reversed() || creditsTl.paused()) {
    creditsTl.play();
  } else {
    creditsTl.reverse();
  }
});






  }, {  });
  // End of useGSAP

  // ---------------------- >
// EOF Preloader script


    















  return (


    
    

    


    // You MUST add these HTML tags to any REACT Applciation for ScrollSmoother to work.
    // <ScrollToTop /> 

  <div className="main_bg">
  
  



         <Header />
     <div id="smooth-wrapper" >
       <div id="smooth-content" className="layout-content-wrapper">
          <Router />


         <Footer />
        <div className="ui-left-line"></div>
        <div className="ui-right-line"></div>
     </div>
    </div>




  </div>
  

  );
}

export default App;